// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout_page__ulGah {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /* Prevent horizontal overflow */
  overflow-x: hidden;
  width: 100%;
}

.Layout_main__FxQfo {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  /* Ensure main content takes full width */
  width: 100%;
}

/* Safe area insets for modern mobile devices (notch, etc.) */
@supports (padding: env(safe-area-inset-bottom)) {
  .Layout_page__ulGah {
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Layout.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,WAAW;AACb;;AAEA,6DAA6D;AAC7D;EACE;IACE,uCAAuC;IACvC,yCAAyC;EAC3C;AACF","sourcesContent":[".page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  /* Prevent horizontal overflow */\n  overflow-x: hidden;\n  width: 100%;\n}\n\n.main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  /* Ensure main content takes full width */\n  width: 100%;\n}\n\n/* Safe area insets for modern mobile devices (notch, etc.) */\n@supports (padding: env(safe-area-inset-bottom)) {\n  .page {\n    padding-left: env(safe-area-inset-left);\n    padding-right: env(safe-area-inset-right);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Layout_page__ulGah`,
	"main": `Layout_main__FxQfo`
};
export default ___CSS_LOADER_EXPORT___;
